import React, { useState } from 'react';
import { AlertTriangle, Trash2 } from 'lucide-react';
import { joinApiPath } from '@/lib/api-config';

const AccountDangerZone: React.FC<{ projectId?: string }> = ({ projectId }) => {
  const [confirmText, setConfirmText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleDelete = async () => {
    if (confirmText !== 'DELETE MY ACCOUNT') return;
    setSubmitting(true);
    try {
      await fetch(joinApiPath('account', 'delete'), {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId })
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4">
        <div className="flex items-center gap-3 mb-2">
          <AlertTriangle className="w-5 h-5 text-red-400" />
          <h4 className="text-red-400 font-mono text-sm uppercase">Danger Zone</h4>
        </div>
        <p className="text-white/70 text-xs font-mono mb-3">
          Deleting your account will remove your user, profiles, executions, and stored assets. This action is irreversible.
        </p>
        <div className="space-y-3">
          <input
            type="text"
            placeholder="Type DELETE MY ACCOUNT to confirm"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            className="w-full bg-black/50 border border-red-500/30 rounded p-2 text-white/90 font-mono text-sm focus:outline-none focus:border-red-500/50"
          />
          <button
            onClick={handleDelete}
            disabled={confirmText !== 'DELETE MY ACCOUNT' || submitting}
            className="btn-future text-red-400 border-red-400/50 hover:bg-red-400/10 flex items-center gap-2 disabled:opacity-50"
          >
            <Trash2 className="w-4 h-4" />
            {submitting ? 'DELETING…' : 'DELETE ACCOUNT'}
          </button>
          <p className="text-white/50 text-xs font-mono">You may lose access immediately after deletion.</p>
        </div>
      </div>
    </div>
  );
};

export default AccountDangerZone;


